/**
 * Calculate start and end times strings for display
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {string} _start - Start date
 * @param {string} _end - End date
 * @returns {string}
 */
const calcDateTime = (_start, _end) => {
  let start,
    end = null;
  if (_start) start = new Date(_start).toLocaleString('en-US', { timeZone: 'Australia/Melbourne', hour: 'numeric', minute: 'numeric', hour12: true });
  if (_end) end = new Date(_end).toLocaleString('en-US', { timeZone: 'Australia/Melbourne', hour: 'numeric', minute: 'numeric', hour12: true });
  if (start == end) end = null; // clear end time (don't display)

  if (start && end) return `${start} to ${end} AEDT`;
  if (start && !end) return `Starts ${start} AEDT`;
  if (!start && end) return `Ends ${end} AEDT`;
};

/**
 * Random image for local development to bypass Deakin VPN
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {string} imageUrl - Image url
 * @param {integer} id - item id
 * @returns {string}
 */
const getImageURL = (imageUrl, id) => {
  return location.hostname === 'localhost' || location.hostname === '127.0.0.1' ? `https://picsum.photos/seed/${id}/735/412` : imageUrl;
};

/**
 * Compare start and end dates, if end date is greater than start then return endDate for display
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {string} startDate=null
 * @param {string} endDate=null
 * @returns {string}
 */
const calcEndDate = (startDate = null, endDate = null) => {
  if (!startDate || !endDate) return null;
  let sDate = new Date(startDate);
  let eDate = new Date(endDate);
  sDate = sDate.getFullYear() + sDate.getMonth() + 1 + sDate.getDate();
  eDate = eDate.getFullYear() + eDate.getMonth() + 1 + eDate.getDate();
  return eDate > sDate ? endDate : null;
};

/**
 * Compose and transform event items from definitions
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {array} items - array of items
 * @returns {array}
 */
const composeCardEvents = (items) => {
  let composed = [];

  items.forEach((i) => {
    // location
    let location = 'Multiple locations';
    if (typeof i?.location !== 'undefined') {
      if (i.location.length === 1) location = i?.location[0]?.trim();
    }

    composed.push({
      id: i?.id,
      imageUrl: getImageURL(i?.imageUrl, i?.id),
      alt: i?.alt,
      heading: i?.heading,
      url: i?.url,
      datetime: calcDateTime(i?.startDate, i?.endDate),
      location: location,
      startDate: i?.startDate,
      endDate: calcEndDate(i?.startDate, i?.endDate),
      isExternalLink: i.externalLink.toString() === 'true' ? true : false,
    });
  });
  return composed;
};

export default composeCardEvents;
